import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/joy';

const StockAddHeaderButton = ({ onClick, label }) => (
  <IconButton
    variant="solid"
    color="primary"
    onClick={onClick}
    aria-label={label}
    sx={{
      width: 44,
      height: 44,
      minWidth: 44,
      minHeight: 44,
      flexShrink: 0,
      backgroundColor: 'primary.500',
      '&:hover': { backgroundColor: 'primary.600' }
    }}
  >
    <AddIcon />
  </IconButton>
);

export default StockAddHeaderButton;
